// extracted by mini-css-extract-plugin
export default {"container":"signUp_container__TOtq-"};